// extracted by mini-css-extract-plugin
export default {"outer":"Contact_outer__8f5FE","meta":"Contact_meta__ji8Cl"};